import React, { useState, useEffect, useRef, useMemo } from 'react';
import JoditEditor from "jodit-react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import axios from "axios"

import ReturnClass from "../pages/Signup/ReturnClass";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from 'react-spinner-material';


function MasterConcept() {

    const apiurl = window.SERVICE_URL;

    const editor = useRef(null)
    const [content, setContent] = useState('')

    const [AddConcept, setAddConcept] = useState(false);
    const AddConceptClose = () => setAddConcept(false);
    const handleAddConcept = () => setAddConcept(true);

    const [EditConcept, setEditConcept] = useState(false);
    const EditConceptClose = () => setEditConcept(false);
    const handleEditConcept = () => setEditConcept(true);

    const encPartnerID = ReturnClass.PartnerID;
    const [data, dataSet] = useState([]);

    const [DataById, DataByIdSet] = useState([]);
    useEffect(() => {
    }, [DataByIdSet]);



    if (localStorage.getItem("loginsession") != null) {
        const res = JSON.parse(localStorage.getItem("loginsession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.AccessToken = res.AccessToken;
        ReturnClass.UserID = res.UserID;
        ReturnClass.PartnerID = res.PartnerID;
    }


    useEffect(() => {
        GetAllConcept();
    }, [dataSet]);


    function validateFormUpdate(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Concept Name";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddConceptInfo();
            UpdateMasterConcept();

            status = true;
        }
        return status;
    }


    function validateForm(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Concept Name";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddConceptInfo();
            UpdateMasterConcept();

            status = true;
        }
        return status;
    }



    function spinner(e, isTrue) {
        if (isTrue) {
            e.setAttribute("style", "visibility: visible; display: block;");
        } else {
            e.setAttribute("style", "visibility: hidden; display: none;");
        }
    }

    async function GetAllConcept() {

        var spi = document.getElementById('spi');
        spinner(spi, true);
        await axios.get(apiurl + `api/GetAllConcept?PartnerID=` + encPartnerID,

            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {
                spinner(spi, false);
                dataSet(response.data);

            })
            .catch(error => {
                console.log(error.response)
            });
    }


    const AddConceptInfo = async () => {


        var name = document.getElementById("Name1").value;
        var description = document.getElementById("Description1").value;
        const AddConceptInfoForm = {
            Id: 0,
            Name: name,
            Description: description,
            QuestionCount: 0,
            CreatedDate: new Date(),
            PartnerID: 0,
            encPartnerID: ReturnClass.PartnerID,
            Active: ReturnClass.Active
        }
        await axios.post(apiurl + `api/AddConceptInfo`, AddConceptInfoForm,
            {
                headers:
                {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                    "Content-Type": "application/json"
                },
            })
            .then(function (result) {

                toast.success(result.data.outMessage);
                GetAllConcept();
                AddConceptClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };



    async function GetConceptByID(Id) {
        DataByIdSet([]);

        await axios.get(apiurl +`api/GetConceptByID?PartnerID=${encPartnerID}&Id=${Id}`,


            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {

                DataByIdSet(response.data);
            })
            .catch(error => {
                console.log(error.response)
            });

    }

    const UpdateMasterConcept = async () => {

        var name = document.getElementById("Name").value;
        var description = document.getElementById("Description").value;
        var id = document.getElementById("id").value;

        const UpdateMasterConceptForm = {

            Id: id,
            Name: name,
            Description: description,
            QuestionCount: 0,
            CreatedDate: new Date(),
            PartnerID: 0,
            encPartnerID: ReturnClass.PartnerID,
            Active: ReturnClass.Active

        };

        await axios
            .post(apiurl + `api/AddConceptInfo`, UpdateMasterConceptForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {

                toast.success(result.data.outMessage);
                GetAllConcept();
                EditConceptClose();


            })
            .catch(error => {
                console.log(error.response)
            });

    };

    return (
        <>
            <ToastContainer />

            <div>
                <div className="alert alert-light d-flex align-items-center mb-3 px-4">
                    <h5
                        className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                        style={{ fontSize: "14px" }}>
                        Home
                    </h5>
                    <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-danger"></span>
                    <span className="text-danger font-weight-500 f13">Concept Entities</span>
                </div>
            </div>
            <div className="yoc-subheader__main bg-white px-3 mb-3 py-3">
                <Link
                    to="/manage-user"
                    className="btn btn-pill btn-upper font-weight-normal ad-btn text-uppercase btn-orange waves-effect waves-light"
                >
                    Master Settings
                </Link>
                <Link
                    to="/manage-user"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/ Users
                </Link>
                <a
                    type="text"
                    href="#"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/Users Rights
                </a>
            </div>

            <div className="row">
                <div className="col-lg-12 col-xs-12 order-lg-2 order-xl-2">
                    <div className="alert alert-light d-flex align-items-center mb-0 px-3">
                        <span
                            className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--success yoc-badge--rounded cursor-pointer"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            MASTER ENTERIES
                        </span>
                        <div
                            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-md custom_dropdown"
                            x-placement="bottom-end"
                            style={{
                                position: "absolute",
                                willChange: "transform",
                                top: "0px",
                                left: "0px",
                                transform: "translate3d(24px, 26px, 0px)",
                            }}>

                            <ul className="yoc-nav p-3">
                                <li className="yoc-nav__head d-block text-center headingList">
                                    Select Master Entry
                                    <i className="flaticon2-information" data-toggle="yoc-tooltip" data-placement="right" title="" data-original-title="Click to learn more..."></i>
                                </li>
                                <li className="yoc-nav__item  mt-2">
                                    <Link to="/master-question-type" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk custom-lnk">Question's Type</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item  mt-2">
                                    <Link to="/master-settings" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk ">Exam List</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-levels" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Difficulty Level</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-question" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Question Source</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-language" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Language</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-author" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Authors</span>
                                    </Link>
                                </li>

                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-concept" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Concept</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-university" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">University</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__separator"></li>
                            </ul>
                        </div>
                        <span className="seperator ml-lg-3 ml-md-3 ml-sm-3 ml-2"></span>
                        <h5 className="yoc-subheader__title text-uppercase mt-2">Concept</h5>
                        <div style={{ fontSize: "12px", padding: "10px 6px" }}
                            onClick={handleAddConcept}
                            className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--info yoc-badge--rounded cursor-pointer ml-2"> <i
                                className="fa fa-plus "
                                title="Add new level"
                                aria-hidden="true"

                            ></i></div>
                    </div>
                    <div className="yoc-portlet yoc-portlet--height-fluid yoc-portlet--mobile custom-side">
                        <div className="yoc-portlet__body yoc-portlet__body--fit ">
                            <div
                                className="yoc-datatable yoc-datatable--default   yoc-datatable--loaded table-responsive"
                                id="yoc_datatable_latest_orders"
                            >
                                <table className="table " style={{ display: "block" }}>
                                    <thead className="yoc-datatable__head">
                                        <tr className="yoc-datatable__row" style={{ left: "0px" }}>
                                            <th
                                                data-field="ShipName"
                                                data-autohide-disabled="false"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">Name</span>
                                            </th>
                                            <th
                                                data-field="ShipDate"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">Description</span>
                                            </th>
                                            <th
                                                data-field="Status"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">No. of Questions</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="yoc-datatable__body ps ps--active-y">
                                        <tr id="spi" >
                                            <Spinner size={120} spinnerColor={"#333"} spinnerWidth={2} />
                                        </tr>

                                        {data.map((user, key) => (

                                            <tr key={key} className="yoc-datatable__row" style={{ left: "0px" }}>
                                                <td
                                                    data-field="ShipName"
                                                    data-autohide-disabled="false"
                                                    className="yoc-datatable__cell"
                                                    style={{ width: "329px" }}
                                                >
                                                    <div className="yoc-user-card-v2 d-flex">
                                                        <div className="yoc-user-card-v2__pic">
                                                            <strong> {user.name}</strong>
                                                        </div>
                                                        <div
                                                            className="dropdown ml-sm-4"
                                                            style={{
                                                                overflow: "visible",
                                                                position: "relative",
                                                                width: "80px"
                                                            }}
                                                        >
                                                            <a
                                                                data-toggle="dropdown"
                                                                className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="flaticon-more-1"></i>
                                                            </a>
                                                            <div
                                                                className="dropdown-menu dropdown-menu-right ml-sm-4"
                                                                x-placement="bottom-end"
                                                                style={{
                                                                    position: "absolute",
                                                                    willChange: "transform",
                                                                    top: "0px",
                                                                    left: "0px",
                                                                    transform: "translate3d(24px, 26px, 0px)"
                                                                }}
                                                            >
                                                                <ul className="yoc-nav">
                                                                    <li className="yoc-nav__item">
                                                                        <a
                                                                            className="yoc-nav__link"

                                                                            onClick={() => { GetConceptByID(user.id); handleEditConcept(); }}>


                                                                            <i className="yoc-nav__link-icon flaticon2-contract"></i>
                                                                            <span className="yoc-nav__link-text">
                                                                                Edit Source
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                    <li className="yoc-nav__item">
                                                                        <a className="yoc-nav__link" href="#">
                                                                            <i className="yoc-nav__link-icon flaticon2-trash"></i>
                                                                            <span className="yoc-nav__link-text">
                                                                                Delete
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td
                                                    className="yoc-datatable__cell"
                                                    style={{ width: "420px" }}
                                                >
                                                    <span className="pr-sm-3">
                                                        <strong> {user.description}</strong>
                                                    </span>
                                                </td>
                                                <td
                                                    data-field="Actions"
                                                    data-autohide-disabled="false"
                                                    className="yoc-datatable__cell "
                                                >
                                                    <span className="pr-sm-3"><strong> {user.questionCount}</strong></span>
                                                </td>
                                            </tr>
                                        )).reverse()}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={AddConcept}
                onHide={AddConceptClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>ADD CONCEPT</Modal.Title>
                        <Button onClick={AddConceptClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="Name1"
                                    name="name"
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>

                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}

                                    id="Description1"
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateForm}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={AddConceptClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={EditConcept}
                onHide={EditConceptClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>EDIT CONCEPT</Modal.Title>
                        <Button onClick={EditConceptClose}>X</Button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="Id"
                                    aria-describedby=""
                                    id="id"
                                    name="id"
                                    defaultValue={DataById.id}
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    defaultValue={DataById.name}
                                    id="Name"
                                    name="name"

                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    id="Description"
                                    value={DataById.description}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormUpdate}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditConceptClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default MasterConcept